import "../Experience/Experience.scss";
import React from "react";
import Enhanced from "../Enhanced/Enhanced";
import Match from "../match/Match";

export default function Experience() {
	return (
		<div className="experience">
			<Match />
			<Enhanced />
		</div>
	);
}
